module.exports = require("./pt-MO.d.ts");